import { render } from "./NotFound.vue?vue&type=template&id=8f08e81e&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-8f08e81e"

export default script